import React from "react";
import PropTypes from "prop-types";
import { connect, getIn } from "formik";
import classNames from "classnames";
import traverse from "traverse";

import {
  Input as ReactStrapInput
} from "reactstrap";

import ReactSelect from "react-select";

import errorsForField from "./errorsForField";
import withErrors from "./withErrors";

export const DataBag = connect(({ children, formik }) => children(formik));

class ObserveImpl extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    property: PropTypes.string.isRequired,
    formik: PropTypes.object.isRequired
  };

  componentDidUpdate({ formik: prevFormik }) {
    if (prevFormik[this.props.property] !== this.props.formik[this.props.property]) {
      this.props.onChange(prevFormik, this.props.formik);
    }
  }

  render() {
    return null;
  }
}

export const Observe = connect(ObserveImpl);

export function addListFormikAdapter({ field, form, fieldNames, requireTouched }, addListItem) {
  return ({ item, fieldUpdater, index }) => {
    const transformedProps = {};

    fieldNames.forEach((fieldName) => {
      const qualifiedName = `${field.name}[${index}].${fieldName}`;

      transformedProps[fieldName] = {
        name: qualifiedName,
        value: item[fieldName],
        errors: errorsForField(form, qualifiedName, { requireTouched }),
        onChange: fieldUpdater(fieldName),
        onBlur: (e) => form.handleBlur(e)
      };
    });

    return addListItem(transformedProps);
  };
}

export const Input = withErrors(({ field, form, fieldErrors, ...props }) => <ReactStrapInput {...field} {...props}/>);

export function Checkbox(props) {
  return (
    <Input
      {...props}
      type='checkbox'
      checked={props.field.value}
      onChange={({ target: { checked } }) => props.form.setFieldValue(props.field.name, checked)}
    />
  );
}

Checkbox.propTypes = {
  field: PropTypes.any.isRequired,
  form: PropTypes.any.isRequired
};

export function RadioButton(props) {
  const field = props.field;

  return (
    <Input
      {...props}
      type='radio'
      checked={field.value === props.value}
    />
  );
}

RadioButton.propTypes = {
  field: PropTypes.any.isRequired,
  value: PropTypes.string.isRequired
};

export const Select = withErrors(({ options, field, form, fieldErrors, ...props }) => (
  <ReactSelect
    options={options}
    classNamePrefix="react-select"
    className={classNames({
      "react-select": true,
      "is-invalid": field.invalid
    })}
    name={field.name}
    value={options ? options.find(option => option.value === field.value) : ''}
    onChange={(option) => form.setFieldValue(field.name, option ? option.value : '')}
    onBlur={field.onBlur}
    styles={{ menu: base => ({ ...base, zIndex: 999 }) }}
    {...props}
  />
));

Select.propTypes = {
  options: PropTypes.any.isRequired,
  field: PropTypes.any.isRequired,
  form: PropTypes.any.isRequired
};

export function Debug() {
  return (
    <DataBag>
      {(bag) => (
        <pre>{JSON.stringify(bag, null, 2)}</pre>
      )}
    </DataBag>
  );
}

function convertTraversePathToLodashPath(traversePath) {
  return traversePath.reduce((acc, pathPart) => {
    if (pathPart.match(/\d+/)) {
      return `${acc}[${pathPart}]`;
    } else if (acc.length === 0) {
      return pathPart;
    } else {
      return `${acc}.${pathPart}`;
    }
  }, "");
}

export function unchangedFields(prevValues, values) {
  const prevValuesTraverser = traverse(prevValues);

  return traverse(values).reduce(function(acc, value) {
    if (this.isLeaf) {
      const prevValue = prevValuesTraverser.get(this.path);

      if (prevValue === value) {
        acc.push(convertTraversePathToLodashPath(this.path));
      }
    }

    return acc;
  }, []);
}
